import { EVENT_NAMES as FLOATING_ELEMENT_EVENTS } from '@Core/components/floatingElementManager/events';
import { DEFAULT_BOTTOM, selectors, cssVars } from './config';

export default class Repositioner {
  ICON_OFFSET = 20;

  updatingPosition = false;

  FloatingElementManager;
  floatingElementLayout;
  widgetContainer;

  constructor() {
    this.attachCoreListeners();
  }

  updatePosition() {
    const MAX_RUNTIME = 300;
    let framesRun = 0;

    const callback = () => {
      if (framesRun === MAX_RUNTIME) {
        this.updatingPosition = false;
        return;
      }

      const topEdge = this.FloatingElementManager.topEdgePosition();
      const newPosition = topEdge + this.ICON_OFFSET;
      this.updateBottomCssVar(`${newPosition}px`);

      framesRun += 1;
      window.requestAnimationFrame(callback);
    };

    this.updatingPosition = true;
    window.requestAnimationFrame(callback);
  }

  updateBottomCssVar(value = DEFAULT_BOTTOM) {
    this.widgetContainer.style.setProperty(cssVars.bottom, value);
  }

  attachCoreListeners() {
    window.addEventListener(FLOATING_ELEMENT_EVENTS.MOUNTED, (e) => {
      this.FloatingElementManager = e.detail;
    });
  }

  mount(widgetContainer) {
    this.widgetContainer = widgetContainer;
    this.floatingIcon = widgetContainer.querySelector(selectors.floatingButton);
    this.FloatingElementManager.watch(() => {
      if (this.updatingPosition) return;

      this.updatePosition();
    });
  }
}
